import { element } from 'protractor';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StopComponent } from './stop/stop.component';
import { TranslateService } from '@ngx-translate/core';
import { DialogComponent } from './dialog/dialog.component';
import { ExtendComponent } from './extend/extend.component';
import { Router } from '@angular/router';
import { BookService } from './../../../api/book.service';
import { ConfirmComponent } from './confirm/confirm.component';
import { Component, OnInit, Input } from '@angular/core';
import { BookResult } from 'src/app/models/api_models/book';
import { StationDetail } from 'src/app/models/api_models/station';
import { StationData, LeafletMapStationZoomComponent } from 'src/app/leaflet/leaflet-map-station-zoom/leaflet-map-station-zoom.component';
import { MatDialog } from '@angular/material/dialog';
import { StationService } from 'src/app/api/station.service';
import { Station } from 'src/app/models/erp_models/station';
import { DomSanitizer } from '@angular/platform-browser';
import { InstructionComponent } from './instruction/instruction.component';

@Component({
  selector: 'app-book-info-block',
  templateUrl: './book-info-block.component.html',
  styleUrls: ['./book-info-block.component.scss']
})
export class BookInfoBlockComponent implements OnInit {

   _start;


   _end;

  img = "";
  getImg() {
    this.img = "data:" + this._station.image.mimetype + ";base64, " + this._station.image.file;
  }

  private _book: BookResult;
  get book(): BookResult {
    return this._book;
  }
  @Input()
  set book(book: BookResult) {
    this._book = book;
    this._start = this._book.startdate;
    this._end = this._book.enddate;
    // this._start.setTime(this._start.getTime() - 1000 * 60 * 60 * 2);
    // this._end.setTime(this._end.getTime() - 1000 * 60 * 60 * 2);
    this.stationId = this._book.station_id;
  }


  private _station: StationDetail = null;
  get station(): StationDetail {
    return this._station;
  }
  @Input()
  set station(station: StationDetail) {
    this._station = station;
  }

  displayLeafletDialog() {
    this.dialog.open(LeafletMapStationZoomComponent, {
      data: new StationData,
    });
  }

  private _stationId: number = null;
  get stationId(): number {
    return this._stationId;
  }
  @Input()
  set stationId(stationId: number) {
    this._stationId = stationId;
    if (this._stationId != null) {
      this.stationService.getStationDetailFromId(this._stationId).subscribe(
        response => {
          this._station = response;
          this.getImg();
        });
    }
  }



  // delete reservation 
  // openDialogDelete(): void {
  //   const dialogRef = this.dialog.open(ConfirmComponent, {
  //     width: '350px',
  //     height: '140px',
  //     data: this.translate.instant('RESERVATION.DETAIL.MESSAGECANCEL')
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       this.bookService.cancelBook(this._book.id).subscribe(
  //         response => {
  //           this.openDialog()
  //         }
  //       )
  //     }
  //   });
  // }


// extend reservation
  // openDialogExtend(): void {
  //  this.dialog.open(ExtendComponent, {
  //     width: '850px',
  //     height: '330px',
  //     data: this.book
  //   });

  // }

//convert date
  getDateFormat(str : string){
  //  console.log(str)
    var newString = str.replace('-','/').replace('-', '/').replace('T',' ').replace(':00Z','');
   return  newString
  }
  
  


  // open  instruction 
  openDialogInstruction(element): void {
    const dialogRef = this.dialog.open(InstructionComponent, {
      // width: '850px',
      // height: '630px',
      data: {book: this.book, element: element}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.NewDetailResa()
    });



  }

  openDialogStop(element): void {
    
      const dialogRef = this.dialog.open(StopComponent, {
        // width: '850px',
        // height: '430px',
        data: {book: this.book, element: element}
      });

      dialogRef.afterClosed().subscribe(result => {
        this.NewDetailResa()
      });

   

  }



  NewDetailResa(){ 

    let lang = this.translate.currentLang

    this.bookService.getBookDetail(this.book.id, lang).subscribe(
         response => { 
           this.book = response;
         } )
 }


// etat vehicule
// openCarChecking(): void {
  
//   window.open(this.book.actions.add_button.url, '_blank');

//   console.log(this.book)
//   if(this.book.actions?.add_button)
//   {

//     this.NewDetailResa();
//     setInterval(() => {
//         this.NewDetailResa(); 
//         }, 2000);

//   }
  
 
//  }



  // confirmation 
  openDialog(): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      // width: '350px',
      // height: '110px',
      data:  this.translate.instant('RESERVATION.DETAIL.MESSAGECONFIRMECANCEL')
    });

    dialogRef.afterClosed().subscribe(result => {
         this.router.navigate([`/auth/reservations`]);
    });
  }



  actionBook(element){
    console.log(element.type) 
    //-------------------------------------------------------------- standard -------------------------------------------------
    if(element.type === 'standard'){

      this.bookService.actionRemote(element.url).subscribe(
        data => {

          if(data.success === false){

            this.openSnackBarError(data.message)
          }
          else{

            this.openSnackBarDone(data.message)
            this.NewDetailResa()
          }
        
        },
        err => {
          console.log(err)
          this.openSnackBarError(err.message)
        });

    }
    //------------------------------------------------- webview -------------------------------------------------------------- 
    if(element.type === 'webview'){

      window.open(element.url, '_blank');
      console.log(this.book)
    }
    //------------------------------------------------ cancel ---------------------------------------------------------------
    if(element.type === 'cancel'){

      const dialogRef = this.dialog.open(ConfirmComponent, {
        width: '350px',
        height: '140px',
        data: this.translate.instant('RESERVATION.DETAIL.MESSAGECANCEL')
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.bookService.cancelBook(this._book.id).subscribe(
            response => {
              this.openDialog()
            }
          )
        }
      });
    }
    //-------------------------------------------------------- extend -------------------------------------------------------
    if(element.type === 'extend'){

      this.dialog.open(ExtendComponent, {
        width: '850px',
        height: '330px',
        data: this.book
      });

    }
    //---------------------------------------------------------- start -----------------------------------------------------
    if(element.type === 'start'){

      this.openDialogInstruction(element)

    }
     //---------------------------------------------------------- stop -----------------------------------------------------
    if(element.type === 'stop'){

      this.openDialogStop(element)

    }

  }




  openSnackBarDone(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['sucess-snackbar'],
      duration: 20000,
    });
  }


  openSnackBarError(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['error-snackbar'],
      duration: 20000,
    });
  }


  constructor(private snackBar: MatSnackBar, public translate: TranslateService, private router: Router, private bookService: BookService, private stationService: StationService, public dialog: MatDialog, public _DomSanitizationService: DomSanitizer) { }

  ngOnInit() {
  }

}
